<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    Explore

  .u-mb-md

</template>

<script>
import Explore from '~/components/Explore';

export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    Explore
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Explore Baianat",
    "pageDesc":"Discover more about Baianat company and its services, work, ventures, events, books, labs, atlas, arcade and more.",
    "mantra":"Discover Baianat."
  },
  "ar": {
    "pageTitle":"اكتشف بيانات",
    "pageDesc":"اكتشف المزيد حول ما تقدمه شركة بيانات وخدماتها وأعمالها ومشاريعها والفعاليات التي تؤسسها والكتب والمختبرات والمراكز وأطلس.",
    "mantra":"اكتشف بيانات"
  }
}
</i18n>
